import React, { Component } from 'react';
import { FYW_URLS } from '../helpers/api/API_URLS';
import { basicGET } from '../helpers/api/fetchParams';

import { SearchForm } from '../helpers/uiComponents/Search';
import { ActionTabs } from '../helpers/uiComponents/ActionTabs';
import { CloseProfile } from '../helpers/uiComponents/CloseProfile';
import { ResultList } from '../helpers/uiComponents/ResultList';
import { InputRow } from '../helpers/uiComponents/InputRow';

import {
	showPopup,
	hidePopup,
	accordian,
	} from '../helpers/uiFunctions/uiActions';
import { valueEmpty } from '../helpers/uiFunctions/uiHelpers';

class FlooringYouWell extends Component {
	constructor(props) {
		super(props);
		this.state = {
			dealers: [],
			allDealers: [],
			filter: "all",
			currentRetailer: [],
			currentLocations: [],
			linkBaseUrl: "https://staging.flooringyouwell.com/",
		}
		this.loadRetailer = this.loadRetailer.bind(this);
		this.updateRetailer = this.updateRetailer.bind(this);
		this.updateLocation = this.updateLocation.bind(this);
		this.setFilter = this.setFilter.bind(this);
	}
	componentDidMount() {
		fetch(FYW_URLS.listRetailers, basicGET(localStorage.getItem("token")))
		.then(response => {
			if (response.ok) { return response.json(); } 
			else { throw new Error('Something went wrong ...'); }
		})
		.then(data => {
			this.setState({ allDealers: data, dealers: data });
		})
		.catch(error => {
			console.log(error);
		});
	}
	upload(fieldId, parse) {
		var formData = new FormData();
		var newFile = document.getElementById(fieldId).files[0];
		formData.append('file', newFile);
		// console.log(newFile);

		if(newFile){
			var fileParams = {
				headers: {
					"authorization": "Bearer " + localStorage.getItem("token"),
				},
				body: formData,
				method: "POST",
			}

			fetch("https://leadgen.mm-api.agency/" + parse, fileParams)
			.then(response => {
				if (response.ok) { return response.json(); } 
				else { throw new Error('Something went wrong ...'); }
			})
			.then(data => {
				console.log(data);
			})
			.catch(error => {
				console.log(error);
			});

			document.getElementById("upload-message").innerHTML = "File Uploaded...";
			setTimeout(function() {
				document.getElementById("upload-message").innerHTML = "";
				document.getElementById("upload-message").innerHTML = "Please upload .xlsx Files Only";
			}, 2000);
		} else {
			document.getElementById("upload-message").innerHTML = "Please Choose A Valid File";
			setTimeout(function() {
				document.getElementById("upload-message").innerHTML = "Please upload .xlsx Files Only";
			}, 2000);
		}
	}
	download(filePath, buttonId) {
		let anchor = document.createElement("a");
		anchor.setAttribute("id", "download-"+buttonId);
		document.body.appendChild(anchor);

		let icon = document.querySelectorAll("#"+buttonId+" .fa-download")[0];
		icon.classList.toggle("fa-download");
		icon.classList.toggle("fa-spinner");

		let date = "";
		if (buttonId === "new-locations") {
			date = document.getElementById("new-locations-from-date").value;
		}

		let file = "//leadgen.mm-api.agency"+filePath+date;

		fetch(file, basicGET(localStorage.getItem("token")))
		.then(response => {
			if (response.ok) { return response.blob(); }
			else { throw new Error('Something went wrong ... '); }
		})
		.then(blobby => {
	        let objectUrl = window.URL.createObjectURL(blobby);

	        anchor.href = objectUrl;
	        anchor.download = buttonId+'.csv';
	        anchor.click();

	        window.URL.revokeObjectURL(objectUrl);

	        icon.classList.toggle("fa-download");
			icon.classList.toggle("fa-spinner");
	    })
	    .catch(error => {
			console.log(error);
		});
	}
	loadRetailer(id) {
		this.setState({
			currentRetailer: [],
			currentLocations: []
		});
		setTimeout(() => {
			var retailer = this.state.dealers.filter(obj => {
				return obj.retailerCode === id;
			});
			this.setState({
				currentRetailer: retailer[0],
				currentLocations: retailer[0].locations
			});			
		}, 250);

		document.querySelectorAll("#manufacturer-profile-column .profile")[0].style.display = "block";

	}
	updateRetailer(e) {
		var key = e.target.name;
		var value = e.target.value;
        var newState = this.state.currentRetailer;

        console.log(key, value);

        newState[key] = value;

        this.setState({currentRetailer: newState});
	}
	updateLocation(e) {
		var locationCode = e.target.attributes.customdata.value;
		var key = e.target.name;
		var value = e.target.value;
		console.log(locationCode, key, value);

		let newState = this.state.currentLocations;
		const keyIndex = this.state.currentLocations.findIndex(location => location.locationCode === locationCode );

		if (key === "sale" || key === "paidSearch" || key === "coretec" || key === "financing") {
  			if (value === "on") {
  				value = true;
  			} else{
  				value = false;
  			}
  		}

        newState[keyIndex] = {...newState[keyIndex], [key]: newState[keyIndex][key] = value};
        console.log(newState);

        this.setState({currentLocations: newState});
	}
	saveRetailer() {
		var retailer = this.state.currentRetailer;		
		console.log(retailer);

		var saveParams = {
			headers: {
				"authorization": "Bearer " + localStorage.getItem("token"),
				"Accept" : "application/json",
				"Content-Type": "application/json",
			},
			body: JSON.stringify(retailer),
			method: "POST",
		}
		fetch(FYW_URLS.retailer, saveParams)
		.then(response => {
			if (response.ok) { return response.json(); } 
			else { throw new Error('Something went wrong ... '); }
		})
		.then(data => {
			console.log(data);
		})
		.catch(error => {
			console.log(error);
		});
	}
	saveLocations() {
		
		let locations = this.state.currentLocations;
		for (var i = 0; i < locations.length; i++) {
			delete locations[i].urls;
		}
		console.log(locations);

		// var saveParams = {
		// 	headers: {
		// 		"authorization": "Bearer " + localStorage.getItem("token"),
		// 		"Accept" : "application/json",
		// 		"Content-Type": "application/json",
		// 	},
		// 	body: JSON.stringify(location),
		// 	method: "POST",
		// }
		// fetch(FYW_URLS.location, saveParams)
		// .then(response => {
		// 	if (response.ok) { return response.json(); } 
		// 	else { throw new Error('Something went wrong ... '); }
		// })
		// .then(data => {
		// 	console.log(data);
		// 	// this.loadRetailer(id);
		// })
		// .catch(error => {
		// 	console.log(error);
		// });

	}

	tabChange(id) {
		// console.log(id);
		var tabs = document.querySelectorAll("#retailer-store-tabs .tab");
		var stores = document.querySelectorAll("#retailer-store .tab");
		var i;
		for (i = 0; i < tabs.length; i++) {
			tabs[i].classList.remove("active");
		}
		for (i = 0; i < stores.length; i++) {
			stores[i].classList.remove("active");
		}
		document.querySelectorAll("#retailer-store-tabs .tab.store-"+id)[0].classList.add("active");
		document.querySelectorAll("#retailer-store #store-"+id)[0].classList.add("active");
	}

	setFilter(status, i) {
		var newClients = this.state.allDealers;
		var menuItems = document.querySelectorAll('#flooring-you-well .list-tabs .tab');
		
		for (var x = menuItems.length - 1; x >= 0; x--) {
			menuItems[x].classList.remove('active');
			menuItems[i-1].classList.add('active');
		}

		if (status === "all") {
			// silence is golden
		} else if (status === "sale") {
			newClients = newClients.filter(client => { return client.locations.find(loc => loc.sale === true)});
		} else if (status === "paidSearch") {
			newClients = newClients.filter(client => { return client.participant === true});
		}
		this.setState({
			dealers: newClients,
			filter: status,
		});
	}

	changeDestination(url) {
		this.setState({linkBaseUrl: url});
	}




	render() {
		const { dealers, currentRetailer, currentLocations, linkBaseUrl } = this.state;
		//console.log(linkBaseUrl);
		return (
			<div className="columns">
				<div className="column left-column" id="manufacturers-column">
					<button className="button" onClick={() => showPopup("retailer-controls")} style={{width: '100%'}}>
						Upload/Download Data <i className="fas fa-upload icon"></i>
					</button>
					<section id="retailer-controls" className="section popup-form" style={{display: 'none'}}>
						<i className="fas fa-times icon" onClick={() => hidePopup("retailer-controls")} style={{float: 'right'}}></i>
						<h3>Upload/Download Data</h3>
						<div id="upload-message">All Downloads are .CSV, All Uploads are .xlsx</div>
						<div className="col left">
							<h2 style={{textAlign: "center"}}>Upload</h2>

							<div className="upload-wrapper">
								<h4>Dealer Location Upload</h4>
								<input type="file" name="dealerlistUpload" id="dealerlistUpload" defaultValue="" accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" />
								<button className="button" onClick={() => this.upload("dealerlistUpload", "shaw/parse")} >
									Upload <i className="fas fa-upload icon"></i>
								</button>
							</div>

							<div className="upload-wrapper">
								<h4>Convirza/Phone Number Upload</h4>
								<input type="file" name="convirzaUpload" id="convirzaUpload" defaultValue="" accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" />
								<button className="button" onClick={() => this.upload("convirzaUpload", "fml/convirza/parse")} >
									Upload <i className="fas fa-upload icon"></i>
								</button>
							</div>

						</div>
						<div className="col right">
							<h2 style={{textAlign: "center"}}>Download</h2>

							<div className="upload-wrapper">
								<h4>All Locations</h4>
								<button id="locations" className="button" onClick={() => this.download("/fyw/locations.csv?startDate=", "locations")}>
									Download<i className="fas fa-download icon"></i>
								</button>
							</div>
							<div className="upload-wrapper">
								<h4>New Locations</h4>
								<label>Providing no date will download All Locations...</label>
								<label>Build list of locations that are new adds from this date:</label>
								<input type="date" id="new-locations-from-date" />
								<button id="new-locations" className="button" onClick={() => this.download("/fyw/locations.csv?startDate=", "new-locations")}>
									Download<i className="fas fa-download icon"></i>
								</button>
							</div>
							<div className="upload-wrapper">
								<h4>Paid Search Participants</h4>
								<button id="participants" className="button" onClick={() => this.download("/fyw/participants.csv", "participants")}>
									Download<i className="fas fa-download icon"></i>
								</button>
							</div>
							<div className="upload-wrapper">
								<h4>Paid Search Keywords</h4>
								<button id="keywords" className="button" onClick={() => this.download("/fyw/keywords.csv", "keywords")}>
									Download<i className="fas fa-download icon"></i>
								</button>
							</div>
							<div className="upload-wrapper">
								<h4>Paid Search Ads</h4>
								<button id="psAds" className="button" onClick={() => this.download("/fyw/ads.csv", "psAds")}>
									Download<i className="fas fa-download icon"></i>
								</button>
							</div>
						</div>
					</section>
					<section className="section">
						<h3>Browse Shaw Retailers: {dealers.length}</h3>
						<SearchForm page="flooring-you-well" />
					</section>
					<div className="list-tabs">
						<div className="tab active" onClick={() => this.setFilter("all", 1)}>All Retailers</div>
						<div className="tab" onClick={() => this.setFilter("sale", 2)}>Sale Participants</div>
						<div className="tab" onClick={() => this.setFilter("paidSearch", 3)}>Paid Search Particpants</div>
					</div>
					<div className="list-label">RETAILER NAME <span className="uptime-label">Paid Search?</span></div>

					<ResultList
						page={"flooring-you-well"}
						data={dealers}
						load={this.loadRetailer}
					/>

				</div>
				<div className="column profile-column" id="manufacturer-profile-column">
					<div className="profile">
						<div className="profile-header">
							<h3 className="profile-name">{currentRetailer.name}</h3>
							<CloseProfile />
						</div>
						<div className="profile-form">
{/* GENERAL INFORMATION */}
							<div className="input-group">
								<div className="accordian-title" onClick={accordian}>
									<h4>Account Information</h4>
								</div>
								<div className="accordian-body">
									<ActionTabs 
										handleSave={() => this.saveRetailer(currentRetailer.affiliateCode)}
									/>
									<div id="retailer-account" className="inputs">
										<InputRow label="Retailer Name" type="text" value={currentRetailer.name} property="name" onChange={this.updateRetailer} />
										<InputRow label="affiliateCode (internal use only, unique MM code to identify the retailer)" type="text" value={currentRetailer.affiliateCode} property="affiliateCode" disabled />
										<InputRow label="Client Identifier (Code that the client uses to identify the retailer, may be sensitive information)" type="text" value={currentRetailer.clientIdentifier} property="clientIdentifier" disabled />
									</div>
								</div>
							</div>
{/* STORE LOCATIONS */}
							<div className="input-group">
								<div className="accordian-title" onClick={accordian}>
									<h4>Store Locations</h4>
								</div>
								<div className="accordian-body">
									<ActionTabs
										handleSave={() => this.saveLocations(currentRetailer.affiliateCode)}
										tabs={currentLocations}
										id={"retailer-store"}
									/>
									<div id="retailer-store-inputs" className="inputs">
										{currentLocations.map((location, index) =>
											<div key={index} id={"retailer-store-"+index} className={"tab retailer-store-"+index}>
{/* STORE INPUTS */}
												<div className="store-inputs">
													<h2>Store Information</h2>
													<input type="hidden" name="clientIdentifier" value={valueEmpty(location.clientIdentifier)} />
													<input type="hidden" name="licenseNumber" value={valueEmpty(location.licenseNumber)} />
													
													<InputRow label="Client Code (code used by MM to identify a location, stable)" type="text" value={location.clientCode} property="clientCode" disabled />
													<InputRow label="Location Code (code used by client to identify their locations, unstable, aka Dealer ID)" type="text" value={location.locationCode} property="locationCode" disabled />

													<InputRow onChange={this.updateLocation} data={location.locationCode} label="Name" type="text" value={location.name} property="name" />
													<InputRow onChange={this.updateLocation} data={location.locationCode} label="Active SFN Member" type="checkbox" value={location.active} property="active" />

													<InputRow onChange={this.updateLocation} data={location.locationCode} label="Address 1" type="text" value={location.address1} property="address1" />
													<InputRow onChange={this.updateLocation} data={location.locationCode} label="Address 2" type="text" value={location.address2} property="address2" />
													<InputRow onChange={this.updateLocation} data={location.locationCode} label="City" type="text" value={location.city} property="city" />
													<InputRow onChange={this.updateLocation} data={location.locationCode} label="State" type="text" value={location.state} property="state" />
													<InputRow onChange={this.updateLocation} data={location.locationCode} label="Country" type="text" value={location.country} property="country" />
													<InputRow onChange={this.updateLocation} data={location.locationCode} label="Postal Code" type="text" value={location.postalCode} property="postalCode" />
													<InputRow onChange={this.updateLocation} data={location.locationCode} label="Store Phone Number" type="text" value={location.phone} property="phone" />
													<InputRow onChange={this.updateLocation} data={location.locationCode} label="Forwarding Phone Number" type="text" value={location.forwardingPhone} property="forwardingPhone" />
													<InputRow onChange={this.updateLocation} data={location.locationCode} label="Store Contact Email" type="text" value={location.email} property="email" />
													<InputRow onChange={this.updateLocation} data={location.locationCode} label="Website URL" type="text" value={location.url} property="url" />

													<InputRow onChange={this.updateLocation} data={location.locationCode} label="Advertising Package" type="text" value={location.adPackage} property="adPackage" />
													<InputRow label="Total Budget" type="text" value={location.totalBudget} property="totalBudget" disabled />
													<InputRow onChange={this.updateLocation} data={location.locationCode} label="Search Budget" type="text" value={location.searchBudget} property="searchBudget" />
													<InputRow onChange={this.updateLocation} data={location.locationCode} label="Social Budget" type="text" value={location.socialBudget} property="socialBudget" />
												</div>
{/* PROMO INFO */}
												<div className="promo-inputs">
													<h2>Promotions</h2>
													<InputRow onChange={this.updateLocation} data={location.locationCode} label="Sale?" type="checkbox" value={location.sale} property="sale" />
													<InputRow onChange={this.updateLocation} data={location.locationCode} label="Paid Search?" type="checkbox" value={location.paidSearch} property="paidSearch" />
													<InputRow onChange={this.updateLocation} data={location.locationCode} label="CoreTec?" type="checkbox" value={location.coretec} property="coretec" />
													<InputRow onChange={this.updateLocation} data={location.locationCode} label="Financing?" type="checkbox" value={location.financing} property="financing" />

													<div className="input-row">
														<h2>Landing Page URLs:</h2>
													</div>
													<button className="button active" onClick={() => this.changeDestination("https://staging.flooringyouwell.com/")}>Staging</button>
													<button className="button" onClick={() => this.changeDestination("https://flooringyouwell.com/")}>Production</button>
													<div className="input-row">	
														<label>
															{location.urls.map((url, index) =>
																<div key={index}>
																	<h3>{url.type} Pages</h3>
																	<p id={url.type} data-id={url.urlId}>SEO URL: <a href={linkBaseUrl+url.seo} target="_blank" rel="noopener noreferrer">{url.seo && linkBaseUrl+url.seo}</a></p><br/>
																	<p id={url.type} data-id={url.urlId}>SEM URL: <a href={linkBaseUrl+url.sem} target="_blank" rel="noopener noreferrer">{url.sem && linkBaseUrl+url.sem}</a></p><br/>
																</div>
															)}
														</label>
													</div>
												</div>
												
											</div>
										)}
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		)
	}
}
export default FlooringYouWell;


// WEBPACK FOOTER //
// ./src/component_fyw/Flooring_You_Well.js